itsoftApp.createModule("toggleTabs", function() {
    var module = this;

    var tabs = document.querySelectorAll('.js-tabs-section');

    var deletePopupHandler = function (el) {
        if (el.classList.contains("js-open-popup")) {
            el.classList.remove("js-open-popup");
            el.removeAttribute("data-popup-selector");
        }
    }

    var initTabToggle = function (tabs) {
        var tabs = tabs;
        var tabsContents = tabs.querySelectorAll(".js-tab-content");
        var tabsItems = tabs.querySelectorAll(".js-tab-name");
        var currentActiveTab = tabs.querySelector(".js-tab-name--active");
        var currentActiveContent = tabs.querySelector(".js-tab-content--active");
        var currentIndex;
        var hash = location.hash;
        var animationFlag = false;

        var goToHash = function (newHash) {
            var element;
            var contentElement;

            if (newHash) {
                var selector = "[data-tab-selector='" + newHash + "']";
                var contentSelector = "[data-content-url='" + newHash + "']";
                element = tabs.querySelector(selector);
                contentElement = tabs.querySelector(contentSelector);
            } else {
                element = tabsItems[0];
                contentElement = tabsContents[0];
            }

            if (element) {
                goToTab(element, contentElement);
            }
        }

        var goToTab = function (tab, content) {
            deletePopupHandler(tab);
            // currentActiveTab.classList.remove("js-tab-name--active");
            // currentActiveContent.classList.remove("js-tab-content--active");
            // currentActiveTab = tab;
            // currentActiveContent = content;
            // currentActiveTab.classList.add("js-tab-name--active");
            // currentActiveContent.classList.add("js-tab-content--active");

            var onCurrentActiveShowTransitionEnd = function () {
                currentActiveContent.removeEventListener("transitionend", onCurrentActiveShowTransitionEnd);
                requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                        currentActiveContent.classList.remove("js-content-show");
                        animationFlag = false;
                    })
                })
            }

            var onActiveHideTransitionEnd = function () {
                currentActiveContent.removeEventListener("transitionend", onActiveHideTransitionEnd);
                currentActiveTab.classList.remove("js-tab-name--active");
                currentActiveContent.classList.remove("js-tab-content--active");
                currentActiveContent.classList.remove("js-content-hide");
                currentActiveTab = tab;
                currentActiveContent = content;
                currentActiveTab.classList.add("js-tab-name--active");
                currentActiveContent.addEventListener("transitionend", onCurrentActiveShowTransitionEnd);
                currentActiveContent.classList.add("js-content-show");
                requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                        currentActiveContent.classList.add("js-tab-content--active");
                    });
                });
            }

            if (!(content.classList.contains("js-tab-content--active")) && animationFlag === false) {
                animationFlag = true;
                currentActiveContent.addEventListener("transitionend", onActiveHideTransitionEnd);
                currentActiveContent.classList.add("js-content-hide");
            }
        }

        var onTabClick = function (evt, index) {
            if (evt.target.hasAttribute("data-tab-selector")) {
                location.hash = evt.target.getAttribute("data-tab-selector");
            } else if (evt.currentTarget.hasAttribute("data-tab-selector")) {
                location.hash = evt.currentTarget.getAttribute("data-tab-selector");
            }
            currentIndex = index;
            goToTab(tabsItems[currentIndex], tabsContents[currentIndex]);
        }

        var addTabClickListener = function (tab, index) {
            tab.addEventListener("click", function (evt) {
                evt.preventDefault();
                onTabClick(evt, index);
            });
        }

        for (var i = 0; i < tabsItems.length; i++) {
            addTabClickListener(tabsItems[i], i);
        }

        if (location.hash) {
            goToHash(location.hash);
        } else {
            deletePopupHandler(tabsItems[0]);
        }

        module.callback.goToHash = goToHash;
    }

    var initTabs = function () {
        if (tabs) {
            for (var i = 0; i < tabs.length; i++) {
                initTabToggle(tabs[i]);
            }
        }
    }

    module.callback = initTabs;
})